import { GetServerSideProps } from 'next';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import { apiRequest } from '../../components/util/requests/requests';
import { PageMetadata } from '../../components/util/SeoMetaInformationComponent/SeoMetaInformationComponent';
import EnergyComponent from '../../components/Energy/energyComponent';

export interface EnergyProps {
    pageMetadata?: PageMetadata;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const pageMetadata = await apiRequest('/page-metas?key=ENERGY');

    return {
        props: {
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
        },
    };
};

const Energy = ({ pageMetadata }: EnergyProps) => {
    return (
        <Layout
            seoMetadata={pageMetadata?.seo}
            defaultMetaTitle={'Noria.no - Insurance Platform - Energy'}
        >
            <EnergyComponent />
        </Layout>
    );
};

export default Energy;
